import { AlertTypes } from '@/plugins/alerts_types'
import { getComissionadoNormalized } from '../plugins/helpers'
import { MensagensSucessoPagamento } from '@/enums/pagamento/mensagensPagamento'

export default {
  methods: {
    async gerarBoletoAlterarPagamento (ids_pedidos) {
      await this.$http.post('/proposta/carrinho/gerar_boleto_alterar_pagamento', {
        ids_pedidos
      })
      return {
        type: AlertTypes.SUCCESS,
        mensagem: MensagensSucessoPagamento.boleto
      }
    },
    async pagarComCartaoAlterarPagamento (ids_pedidos, forma_pagamento, bandeira_cartao, cartao, id_usuario, propostas, valor_unitario) {
      this.$store.commit('setAdditionalLoadingText', 'Processando a transação do cartão, este processo pode levar alguns minutos!')

      const valor_pagamento_multiplo = Number(valor_unitario) * propostas.length
      const id_comissionado = this.$session.get('id_comissionado_venda')
      const id_unidade_negocio = this.$session.get('id_unidade_negocio')
      const id_empresa = this.$session.get('id_empresa')
      const comissionado = getComissionadoNormalized(id_comissionado, this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
      const unidade_negocio = this.$session.get('unidades').find(unidade => unidade.id_unidade_negocio === id_unidade_negocio)
      const empresa = this.$session.get('empresas').find(empresa => empresa.ID_Empresa === id_empresa)

      const id_pedido = ids_pedidos[0]

      return this.$http.post('/proposta/pagar_alterar_pagamento', {
        id_pedido,
        forma_pagamento,
        bandeira_cartao,
        comissionado,
        id_usuario,
        cartao,
        unidade_negocio,
        empresa,
        origem_acesso: this.$session.get('origem_acesso'),
        id_empresa: this.$session.get('id_empresa'),
        gerar_contrato: false,
        quantidade_propostas: ids_pedidos.length,
        ids_pedidos_pagamento_multiplo: ids_pedidos,
        valor_pagamento_multiplo
      }, { options: { showAdditionalLoadingText: true } })
    },
    async gerarLinkPagamentoAlterarPagamento (ids_pedidos, email) {
      await this.$http.post('/proposta/carrinho/gerar_link_carrinho_alterar_pagamento', {
        ids_pedidos,
        email
      })
      return {
        type: AlertTypes.SUCCESS,
        mensagem: MensagensSucessoPagamento.link
      }
    }
  }
}
